import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, TemplateRef } from '@angular/core';
import { DialogPosition, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class FlyOver {
    constructor(private dialog: MatDialog) {}

    public open<T, D = any, R = any>(template: ComponentType<T> | TemplateRef<T>, flyOverOptions: FlyOverOptions<D>): MatDialogRef<T, R> {
        const w = flyOverOptions.width ?? '700px';
        const mw = flyOverOptions.maxWidth ?? '80%';
        let dialogRef = this.dialog.open(template, {
            data: flyOverOptions?.data,
            minHeight: '100%',
            height: '100%',
            width: w,
            maxWidth: mw,
            panelClass: ['fly-over-dialog-container', 'animate__animated', 'animate__slideInRight', 'animate__faster'],
            position: <DialogPosition>{
                top: '0',
                bottom: '0',
                right: '0',
            },
        });
        return dialogRef;
    }
}

export interface FlyOverOptions<D> {
    data?: D;
    width?: string;
    maxWidth?: string;
}
